function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardBrexLarge = function SvgCardBrexLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 153"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 153,
    rx: 16,
    ry: 16,
    style: {
      fill: "#15181d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 62.521c0-.313.085-.62.246-.889l2.706-4.51a1.727 1.727 0 0 1 1.482-.839h12.269c.954 0 1.728.774 1.728 1.728v24.191c0 .954-.774 1.728-1.728 1.728H21.714a1.728 1.728 0 0 1-1.482-.839l-2.706-4.51a1.73 1.73 0 0 1-.246-.889v-15.17Zm20.735-4.51c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248-1.728c-.954 0-1.728.774-1.728 1.728v12.671c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728V58.011c0-.954-.774-1.728-1.728-1.728h-5.76ZM38.015 72.987c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248 1.728c-.954 0-1.728.774-1.728 1.728v5.76c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728v-5.76c0-.954-.774-1.728-1.728-1.728h-5.76Z",
    style: {
      fill: "#34383f",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.928 21.847a6.946 6.946 0 0 0-5.58 2.777l-1.362 1.808a2.983 2.983 0 0 1-2.358 1.178h-24.253v28.995h9.507a6.943 6.943 0 0 0 5.58-2.777l1.363-1.806a2.962 2.962 0 0 1 2.357-1.179h24.278V21.848h-9.532Zm1.989 21.451h-10.161a6.947 6.947 0 0 0-5.58 2.777l-1.362 1.808a2.98 2.98 0 0 1-2.357 1.178h-8.538V35.153h10.162a6.952 6.952 0 0 0 5.578-2.777l1.363-1.806a2.983 2.983 0 0 1 2.357-1.18h8.565l-.027 13.908Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgCardBrexLarge;